// eslint-disable-next-line monorepo/no-internal-import
import type {AuthMedium} from '@aboutyou/user/src/user-state/userStore/types';
import {TrackingPageContext} from '../../../types';

export interface TrackLogoutEvent {
  event: 'logout';
  action: 'successful' | 'error';
  label: AuthMedium | undefined;
  content_name: string;
  page_type: string;
  page_type_id: string;
  customer_id: undefined;
  eh: undefined;
}

export const trackLogout =
  ({
    action,
    label,
    page,
  }: {
    action: 'successful' | 'error';
    label?: AuthMedium;
    page: TrackingPageContext;
  }) =>
  () => {
    const event: TrackLogoutEvent = {
      event: 'logout',
      action,
      label: label || undefined,
      content_name: page.path,
      page_type: page.type,
      page_type_id: `${page.id || ''}`,
      customer_id: undefined,
      eh: undefined,
    };

    return event;
  };
